export default __webpack_public_path__ + "static/media/owl.b5e3ef45.svg";